import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import type { LibraryItem } from "@/api/models/api-types";
import { getUploadedFileUrl, uploadFile } from "@/features/file-upload/api/upload-api";
import { getItemUrl } from "../lib/library-media";
import { captureVideoFrame } from "../lib/video-frames";

/**
 * Videonun verilen andaki karesini PNG olarak yakalayıp girdi olarak Library'ye yükler.
 * Kare okunamazsa (CORS) `FrameAccessError`, yükleme başarısızsa API hatası fırlatır.
 */
export const useCaptureFrame = () => {
  const queryClient = useQueryClient();

  const captureFrame = useCallback(
    async (item: LibraryItem, time: number) => {
      const baseName = (item.title || "frame").replace(/\.[^.]+$/, "");
      const fileName = `${baseName}-${time.toFixed(2).replace(".", "_")}s.png`;

      const frameFile = await captureVideoFrame(getItemUrl(item), time, fileName);
      const uploaded = await uploadFile({ file: frameFile, title: fileName, isInput: true });
      queryClient.invalidateQueries({ queryKey: ["library"] });
      queryClient.invalidateQueries({ queryKey: ["library-stats"] });

      return { uploaded, fileName, frameUrl: getUploadedFileUrl(uploaded) };
    },
    [queryClient]
  );

  return { captureFrame };
};
